export function thumb(url: string): string {
  return url.replace(/\/1600\.jpg$/, "/240.jpg");
}

export function productUrl(id: string, cardType: string | null | undefined): string {
  const host = (cardType ?? "").toLowerCase().startsWith("sports") ? "www.sportscardspro.com" : "www.pricecharting.com";
  return `https://${host}/offers?product=${encodeURIComponent(id)}`;
}

export function isSports(consoleName: string | null | undefined, cardType: string | null | undefined): boolean {
  return /cards/i.test(consoleName ?? "") || (cardType ?? "").toLowerCase() === "sports";
}
